import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-md-6 mx-auto" }
const _hoisted_2 = { class: "dl-horizontal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("dt", null, "ID", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("dt", null, "Name", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("dt", null, "Type", -1)
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("dt", null, "Status", -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("dt", null, "Reward Type", -1)
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("dt", null, "Bet costs", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("dt", null, "Image", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("dt", null, "Icon", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("dt", null, "Start time", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("dt", null, "Close time", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("dt", null, "End time", -1)
const _hoisted_18 = { class: "card-footer bg-white border border-light" }
const _hoisted_19 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_image_holder = _resolveComponent("app-image-holder")!
  const _component_milestone_table = _resolveComponent("milestone-table")!
  const _component_leaderboard_table = _resolveComponent("leaderboard-table")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    class: "col-lg-8 mx-auto",
    label: "Event Detail"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("dl", _hoisted_2, [
          _createElementVNode("tr", null, [
            _hoisted_3,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.id), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_4,
            _createElementVNode("dd", null, _toDisplayString(_ctx.model.name), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_5,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.LiveopsOptions.Type, _ctx.model.type)
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_7,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.LiveopsOptions.Status, _ctx.model.status)
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_9,
            _createElementVNode("dd", {
              innerHTML: _ctx.renderOption(_ctx.LiveopsOptions.RewardType, _ctx.model.rewardType)
            }, null, 8, _hoisted_10)
          ]),
          (_ctx.model.isBetCostsShown)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("dd", null, _toDisplayString(_ctx.model.betCosts), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tr", null, [
            _hoisted_13,
            _createElementVNode("dd", null, [
              _createVNode(_component_app_image_holder, {
                image: _ctx.model.image,
                status: _ctx.model.imageStatus
              }, null, 8, ["image", "status"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_14,
            _createElementVNode("dd", null, [
              _createVNode(_component_app_image_holder, {
                image: _ctx.model.icon,
                status: _ctx.model.iconStatus
              }, null, 8, ["image", "status"])
            ])
          ]),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.startTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_16,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.closeTime)), 1)
          ]),
          _createElementVNode("tr", null, [
            _hoisted_17,
            _createElementVNode("dd", null, _toDisplayString(_ctx.formatDate(_ctx.model.endTime)), 1)
          ])
        ])
      ]),
      _createVNode(_component_milestone_table, {
        rows: _ctx.model.milestones,
        "can-edit": _ctx.model.canEditMilestone,
        "on-remove": _ctx.actions.removeMilestone
      }, null, 8, ["rows", "can-edit", "on-remove"]),
      _createVNode(_component_leaderboard_table, {
        rows: _ctx.model.leaderboards,
        "can-edit": _ctx.model.canEditLeaderboard,
        "on-remove": _ctx.actions.removeLeaderboard
      }, null, 8, ["rows", "can-edit", "on-remove"]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_app_button, {
            name: "Translate",
            theme: "info",
            icon: "fa-language",
            to: { name: _ctx.ROUTE_NAME_LIVEOPS.ITEM.TRANSLATE(_ctx.model.rewardType), params: { id: _ctx.model.id } }
          }, null, 8, ["to"]),
          (_ctx.model.rewardType == _ctx.LiveopsRewardType.Milestone)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 0,
                name: "Milestones",
                theme: "info",
                icon: "fa-gift",
                to: { name: _ctx.ROUTE_NAME_LIVEOPS.MILESTONE.INDEX, params: { itemId: _ctx.model.id } }
              }, null, 8, ["to"]))
            : (_ctx.model.rewardType == _ctx.LiveopsRewardType.Leaderboard)
              ? (_openBlock(), _createBlock(_component_app_button, {
                  key: 1,
                  name: "Leaderboard",
                  theme: "info",
                  icon: "fa-trophy",
                  to: { name: _ctx.ROUTE_NAME_LIVEOPS.LEADERBOARD.INDEX, params: { itemId: _ctx.model.id } }
                }, null, 8, ["to"]))
              : _createCommentVNode("", true),
          (_ctx.model.canEnable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 2,
                name: "Enable",
                theme: "success",
                icon: "fa-play",
                onClick: _withModifiers(_ctx.actions.enable, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.model.canDisable)
            ? (_openBlock(), _createBlock(_component_app_button, {
                key: 3,
                name: "Disable",
                theme: "warning",
                icon: "fa-stop",
                onClick: _withModifiers(_ctx.actions.disable, ["prevent"])
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_app_button, {
            name: "Delete",
            theme: "danger",
            icon: "fa-trash-alt",
            disabled: !_ctx.model.canDelete,
            onClick: _withModifiers(_ctx.actions.remove, ["prevent"])
          }, null, 8, ["disabled", "onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}